import React, {useRef, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import TextField from '../../TextField';

import s from './OpenQuestion.css';

export default function OpenQuestion(props) {
  const {total, count, question, onChange, totalPage, currPage} = props;
  const [q] = question;
  const [textValue, setTextValue] = useState('');

  // Carica il testo salvato in Redux per le domande aperte
  const openQuestionsText = useSelector(state =>
    state.getIn(['evaluationQuestions', 'openQuestionsText'], {})
  );

  // Sincronizza il testo da Redux al stato locale
  useEffect(() => {
    const savedText = openQuestionsText[q.id];
    setTextValue(savedText || '');
  }, [q.id, openQuestionsText]);

  const handleChange = ev => {
    const value = ev.target.value;
    setTextValue(value);
    onChange({questionId: q.id, value});
  };

  return (
    <div className={s.OpenQuestion}>
      <div className={s.QuestionContainer}>
        <div className={s.Counter}>
          <sup>{currPage}</sup>
          <span>/</span>
          <sub>{totalPage}</sub>
        </div>

        <div className={s.Text}>
          <label>{q.text} </label>
        </div>
      </div>

      <div className={s.AnswerContainer}>
        <TextField
          id="open-question"
          className={s.TextField}
          placeholder="Ora tocca a te"
          text={textValue}
          multiline
          autofocus
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

OpenQuestion.propTypes = {
  total: PropTypes.number,
  count: PropTypes.number,
  question: PropTypes.array,
  onChange: PropTypes.func,
  totalPage: PropTypes.number,
  currPage: PropTypes.number,
};
